// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/main/personal-settings/set-avatar/set-avatar.scss
// module id = 2082
// module chunks = 50